import { render, staticRenderFns } from "./VipContain.vue?vue&type=template&id=5caeefaa&scoped=true&"
import script from "./VipContain.vue?vue&type=script&lang=js&"
export * from "./VipContain.vue?vue&type=script&lang=js&"
import style0 from "./VipContain.vue?vue&type=style&index=0&id=5caeefaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caeefaa",
  null
  
)

export default component.exports